export class RestoreAccount {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerAccountName",
            "baseName": "providerAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "AccountState",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "AccountVersion",
            "format": ""
        },
        {
            "name": "connectedTime",
            "baseName": "connectedTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "restoreAccountAttributes",
            "baseName": "restoreAccountAttributes",
            "type": "RestoreAccountCloudAttributes",
            "format": ""
        },
        {
            "name": "isJobMetricsEnabled",
            "baseName": "isJobMetricsEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "overrideNetworkConfig",
            "baseName": "overrideNetworkConfig",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "alias",
            "baseName": "alias",
            "type": "string",
            "format": ""
        },
        {
            "name": "isRestoreAllowed",
            "baseName": "isRestoreAllowed",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAccount.attributeTypeMap;
    }
    constructor() {
    }
}
